import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  ViewEncapsulation
} from '@angular/core';
import {SearchTableCellService} from '../search-table-cell.service';
import {map, switchMap, tap} from 'rxjs/operators';
import {Energy} from 'asax-common';
import {ColumnMode, TableColumn} from '@almaobservatory/ngx-datatable';
import {Subscription, timer} from 'rxjs';

const delay = 300;

@Component({
  selector: 'asax-result-table-search-table-cell-frequency-support',
  templateUrl: './cell-frequency-support.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CellFrequencySupportComponent {
  @Input() freqMin: number;
  @Input() freqMax: number;
  @Input() datasetId: string;

  rows: any[];

  columns: TableColumn[] = [
    {name: 'Frequency', prop: 'frequency', width: 150},
    {name: 'Resolution', prop: 'resMax', width: 200},
    {name: 'Sensitivity 10Km/s', prop: 'sens10', width: 200},
    {name: 'Sensitivity native', prop: 'sensBand', width: 200},
    {name: 'Pol. Product', prop: 'polProduct', width: 120},
    {name: 'Type', prop: 'chaNum', width: 100}
  ];

  ColumnMode = ColumnMode;

  isLoading: boolean;

  private timerSubscription: Subscription;

  constructor(private readonly searchTableCellService: SearchTableCellService,
              private readonly ref: ChangeDetectorRef) {
  }

  fetchFrequency(): void {
    this.timerSubscription = timer(delay).pipe(
      tap(() => this.isLoading = true),
      tap(() => this.ref.markForCheck()),
      switchMap(() => this.searchTableCellService.fetchFrequency(this.datasetId)),
      map((energies: Energy[]) => this.mapEnergiesToRows(energies)),
      tap((rows: any[]) => this.rows = rows),
      tap(() => this.isLoading = false),
      tap(() => this.ref.markForCheck())
    ).subscribe();
  }

  private mapEnergiesToRows(energies: Energy[]): any[] {
    return energies.map(energy => ({
        frequency: `${energy.freqMin.toFixed(2)}..${energy.freqMax.toFixed(2)}GHz`,
        resMax: `${energy.resMax.toFixed(2)}kHz`,
        sens10: `${energy.sens10.toFixed(2)}mJy/beam`,
        sensBand: `${energy.sensBand.toFixed(2)}uJy/beam`,
        polProduct: `${energy.polProduct}`,
        chaNum: `${energy.chaNum}`
      })
    );
  }

  @HostListener('mouseenter')
  private onMouseEnter(): void {
    this.fetchFrequency();
  }

  @HostListener('mouseleave')
  private onMouseLeave(): void {
    this.timerSubscription?.unsubscribe();
  }
}
